import { IChartInfo } from "../../common/interfaces/chart.interface";
import {
  IClubBasicInfo,
  IClubData,
  IClubMembers,
  IClubProposals,
  IClubStakings,
  IClubTreasuryOverview,
  IClubVisibilityStatus,
  ITradingTableInfoDto,
  IWithdrawalOverview,
} from "../../common/interfaces/club.interface";
import { get, patch } from "../utilities/http";
import {
  BUY_CHART_INFO,
  CLUB_MEMBERS,
  DASHBOARD_CLUBS,
  DASHBOARD_STAKINGS,
  PROFIT_LOSS,
  PROPOSALS_OVERVIEW,
  SELL_CHART_INFO,
  TOTAL_MONEY_SPEND,
  TREASURY_OVERVIEW,
  TREASURY_TRADING_TABLE,
  WITHDRAWAL_CHART,
  WITHDRAWAL_OVERVIEW,
} from "../utilities/urls";

export function getClubs(): Promise<IClubData[]> {
  return get(DASHBOARD_CLUBS);
}

export function getClubMembers(clubAddress: string): Promise<IClubMembers> {
  return get(`${CLUB_MEMBERS}/${clubAddress}`);
}

export function getClubProposalsOverview(
  clubAddress: string
): Promise<IClubProposals> {
  return get(`${PROPOSALS_OVERVIEW}/${clubAddress}`);
}

export function getClubTreasuryOverview(
  clubAddress: string
): Promise<IClubTreasuryOverview> {
  return get(`${TREASURY_OVERVIEW}/${clubAddress}`);
}

export function getClubBasicInfo(clubAddress: string): Promise<IClubBasicInfo> {
  return get(`${DASHBOARD_CLUBS}/${clubAddress}`);
}

export function getClubStakings(clubAddress: string): Promise<IClubStakings> {
  return get(`${DASHBOARD_STAKINGS}/${clubAddress}`);
}

export function getClubWithdrawalOverview(
  clubAddress: string
): Promise<IWithdrawalOverview> {
  return get(`${WITHDRAWAL_OVERVIEW}/${clubAddress}`);
}

export function getTreasuryTotalMoneySpend(
  clubAddress: string
): Promise<IChartInfo> {
  return get(`${TOTAL_MONEY_SPEND}/${clubAddress}`);
}
export function getTreasuryProfitLoss(
  clubAddress: string
): Promise<IChartInfo> {
  return get(`${PROFIT_LOSS}/${clubAddress}`);
}
export function getTotalMoneySpendForBuyingNFTs(
  clubAddress: string
): Promise<IChartInfo> {
  return get(`${BUY_CHART_INFO}/${clubAddress}`);
}
export function getTotalMoneySpendForSellingNFTs(
  clubAddress: string
): Promise<IChartInfo> {
  return get(`${SELL_CHART_INFO}/${clubAddress}`);
}

export function getTreasuryTradingTable(
  clubAddress: string
): Promise<ITradingTableInfoDto> {
  return get(`${TREASURY_TRADING_TABLE}/${clubAddress}`);
}

export function getWithdrawnAmountChartInfo(
  clubAddress: string
): Promise<IChartInfo> {
  return get(`${WITHDRAWAL_CHART}/${clubAddress}`);
}

export function toggleClubVisibility(
  clubAddress: string,
  isHidden: boolean
): Promise<IClubVisibilityStatus> {
  return patch(`clubs/toggle-visibility/${clubAddress}`, {
    isHidden: isHidden,
  });
}
export default {};
